<script>
    import { onMount } from "svelte";
    import BTN from "../../../system/components/buttons/buttons.svelte";
    import { detectDevice } from "../../../../Controller/Componentes/Aviso/Notificacion/detectDevice";
    import { user } from "../../../../stores/user";
    import {
        panelController,
        enviarNotificacion,  
    } from "../../../../stores/service";
    import Modal from "./../../../system/components/modals/modal.svelte";
    let resolveview;
    let rejectview;
    let modal;
    let buttonAcept;
    let detectDevi 
    onMount(async () => {
    iniview()

    });   
    let formSelect = {
        value: 0,
        active: false,
        styletxt: "",
        messtxt: "",
    };

  async  function iniview(){
        detectDevi = new detectDevice(
        JSON.parse(JSON.stringify($panelController)),
        JSON.parse(JSON.stringify($panelController.service.tableadmins)),
        JSON.parse(JSON.stringify($user.email)),
    );  
    
    
    }

    async function activateAndroidDevice() {
        let status = await detectDevi.ActNotfAndroid();

    console.log(status);
    
        if (status.status == false) {
            modal.Setactivebtn(true, true, false);
            modal.Setinfo({
                title: "Error, no se detecto el dispositivo",
                body: "Interfaz Android no disponible",
            });
        }

        if (status.status) {
            modal.Setactivebtn(true, true, true);
            modal.Setinfo({
                title: "Dispostivo detectado",
                body: `¿Desea vincular el dispositivo ${detectDevi.model}?`,
            });
        }

        let mod = await modal.activeModal();

        if (mod && status.status) {
            

            formSelect.active = false;
            detectDevi.creatingDataBlock();
            await enviarNotificacion({
                token: detectDevi.token,
                title: "Ratingg",
                body: `Se ha activado con exito en el dispositivo ${detectDevi.model}`,
            });

            resolveview(true);
        }
    }

    async function newDevice() {
        switch (formSelect.value) {
            case 1:
                activateAndroidDevice();
                break;

            default:
                break;
        }
    }

    export async function activeview(value) {

        if (detectDevi.validUsvalidate_membershiper(value)) {
        modal.Setactivebtn(false, true, false);
        modal.Setinfo({
                title: "Tienes acceso limitado",
                body: 'Contacte con nosotros para obtener acceso ilimitado',
            });
        let mod = await modal.activeModal();
    }

        formSelect.active = true;
        iniview()
        return new Promise((resolve, reject) => {
            resolveview = resolve;
            rejectview = reject;
        });
    }
</script>

{#if formSelect.active}
    <div class="card text-center">
        <div class="card-header">
            <div class="row center">
                <label for="title">Tipo de dispostivo</label>
            </div>
        </div>
        <div class="card-body">
            <!-- Input de texto -->
            <div class="row">
                <div class="row">
                    <div class="form-group col-md-12">
                        <label for="numero2">Dispostivo:</label>
                        <select
                            class="form-select"
                            aria-label="Default"
                            bind:value={formSelect.value}
                            disabled={false}
                        >
                            <option selected value={0}
                                >Seleccione una opción</option
                            >
                            <option value={1}>Android</option>
                        </select>
                        <p class={formSelect.styletxt}>
                            {formSelect.messtxt}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-body-secondary">
            <BTN
                model="detect"
                bind:this={buttonAcept}
                on:activated={newDevice}
            />
            <BTN
                model="cancel"
                on:activated={() => {
                    resolveview(true);
                    formSelect.active = false;
                }}
            />
        </div>
    </div>
    <Modal bind:this={modal} />
{/if}
